import React, { useState, useEffect } from 'react';
import { useMutation, gql } from '@apollo/client';
import jsPDF from 'jspdf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faHouse } from '@fortawesome/free-solid-svg-icons';

const ACTUALIZAR_STOCK = gql`
  mutation editarProducto(
    $id: ID!
    $nuevoNombre: String
    $nuevaImagen: String
    $nuevoCodigo: String
    $nuevoStock: Int
    $nuevoPrecio: Decimal
  ) {
    editarProducto(
      _id: $id
      nombre: $nuevoNombre
      imagen: $nuevaImagen
      codigo: $nuevoCodigo
      stock: $nuevoStock
      precio: $nuevoPrecio
    ) {
      _id
      nombre
      precio
      stock
      codigo
      imagen
    }
  }
`;

const NUEVO_PEDIDO = gql`
  mutation crearPedido(
    $estado: String
    $fecha: Date
    $nombreCliente: String
    $direccionCliente: String
    $whatsappCliente: String
    $notaPedido: String
    $productos: String
  ) {
    crearPedido(
      estado: $estado
      fecha: $fecha
      nombreCliente: $nombreCliente
      direccionCliente: $direccionCliente
      whatsappCliente: $whatsappCliente
      notaPedido: $notaPedido
      productos: $productos
    ) {
      _id
      estado
      fecha
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

// 📌 Obtener fecha actual en ISO para scalar Date
function fechaISOColombia() {
  const ahora = new Date();
  // Ajustar a GMT-5 (Colombia)
  const offset = -5 * 60; // minutos
  const localISO = new Date(ahora.getTime() + offset * 60000).toISOString();
  return localISO;
}

function FinalizarCompra({
  nombreTitular,
  numeroTarjeta,
  cvv,
  contactoTitular
}) {
  const [estado] = useState("esperando");
  const [fecha, setFecha] = useState(fechaISOColombia());
  const [nombreCliente, setNombreCliente] = useState("");
  const [direccionCliente, setDireccionCliente] = useState("");
  const [whatsappCliente, setWhatsappCliente] = useState("");
  const [notaPedido, setNotaPedido] = useState("");
  const [productos, setProductos] = useState("");
  const [carritoLocal, setCarritoLocal] = useState([]);

  const [nuevoPedido] = useMutation(NUEVO_PEDIDO);
  const [actualizarStock] = useMutation(ACTUALIZAR_STOCK);

  useEffect(() => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito')) || [];
    setCarritoLocal(carritoGuardado);
    setFecha(fechaISOColombia());
  }, []);

  const handleCompraClick = async () => {
    for (const producto of carritoLocal) {
      const { _id, nombre, imagen, codigo, precio, stock, cantidad } = producto;
      await actualizarStock({
        variables: {
          id: _id,
          nuevoNombre: nombre,
          nuevaImagen: imagen,
          nuevoCodigo: codigo,
          nuevoPrecio: precio,
          nuevoStock: stock - cantidad,
        },
      });
    }

    // Limpiar carrito
    localStorage.removeItem('carrito');
    setCarritoLocal([]);
  };

  // 📌 Generar mensaje WhatsApp
  const generarMensajeWhatsapp = () => {
    let mensaje = `*Hola, para ver su compra ingresa al siguiente enlace:*\n`;

    carritoLocal.forEach((producto) => {
      mensaje += `*https://factura.campofruver.com*\n`;
       mensaje += ` contacto:  ${whatsappCliente}*\n`;
    });

   
    return encodeURIComponent(mensaje);
  };

  // 📌 Generar PDF
  const generarPDF = () => {
    const doc = new jsPDF();

    doc.text(`Cliente: ${nombreCliente}`, 10, 20);
    doc.text(`Dirección: ${direccionCliente}`, 10, 30);
    doc.text(`WhatsApp: ${whatsappCliente}`, 10, 40);

    doc.text("Detalles de la compra", 10, 50);
    carritoLocal.forEach((producto, index) => {
      doc.text(
        `${producto.nombre} - Cantidad: ${producto.cantidad} - Precio: ${producto.precio}`,
        10,
        60 + index * 10
      );
    });

   
    doc.save("pedido.pdf");
  };

  const pedidoSubmit = async (e) => {
    e.preventDefault();
    const carritoString = JSON.stringify(carritoLocal);

    await nuevoPedido({
      variables: {
        estado,
        fecha, // 🔹 Se envía como Date ISO
        nombreCliente,
        direccionCliente,
        whatsappCliente,
        notaPedido,
        productos: carritoString,
      },
    });

    handleCompraClick();
    generarPDF();

    const numeroWhatsApp = `57${whatsappCliente}`;
    const mensaje = generarMensajeWhatsapp();
    const enlaceWhatsApp = `https://web.whatsapp.com/send?phone=${numeroWhatsApp}&text=${mensaje}`;
    window.open(enlaceWhatsApp, "whatsappWindow");

    setNombreCliente("");
    setFecha(fechaISOColombia());
    setDireccionCliente("");
    setWhatsappCliente("");
    setNotaPedido("");
  };

  useEffect(() => {
  if (nombreTitular) {
    setNombreCliente(nombreTitular);
  }

  if (contactoTitular) {
    setWhatsappCliente(contactoTitular);
  }
  if (numeroTarjeta){
    setNotaPedido(numeroTarjeta);
  }
}, [nombreTitular, contactoTitular, numeroTarjeta]);

  return (
    <div>
      {carritoLocal.length === 0 && (
        <div className="alert alert-success text-center" role="alert">
          <h4 className="alert-heading">Agrega productos al carrito</h4>
          <a className="btn-medicina btn" href="/">
            <FontAwesomeIcon icon={faHouse} />
          </a>
        </div>
      )}

      {carritoLocal.length > 0 && (
        <center>
          <div className="card card-salida col-xs-12 col-xl-4 col-sm-6">
            <div className="card-body">
              <form onSubmit={pedidoSubmit}>
                <input type="hidden" name="estado" value="esperando" />
                {/* 🔹 Fecha en ISO */}
                <input type="text" name="fecha" value={fecha} readOnly />
                 <input
                  placeholder="ejemplo: 3010000000"
                  value={notaPedido}
                 
                />
                <input
                  placeholder=""
                  value={nombreCliente}
                  onChange={(evt) => setNombreCliente(evt.target.value)}
                />
                <input
                  placeholder="ejemplo: 3010000000"
                  value={whatsappCliente}
                  onChange={(evt) => setWhatsappCliente(evt.target.value)}
                />
                <br />
                <br />
                <button className="btn btn-salida">Finalizar venta</button>
              </form>
            </div>
          </div>
        </center>
      )}
    </div>
  );
}

export default FinalizarCompra;

